function DSyncLogo(props) {
  return (
    <svg
      width={548}
      height={548}
      viewBox='0 0 548 548'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M527.722 427.138c4.263-4.262 4.263-11.173 0-15.435-4.262-4.262-11.172-4.262-15.434 0l15.434 15.435zM26.316 133.787l-7.81-7.624 7.81 7.624zM398.17 519.041H45.841v21.828h352.328v-21.828zm-368.7-16.371V152.846H7.643V502.67H29.47zm482.819-90.967L409.745 514.246l15.434 15.435 102.543-102.543-15.434-15.435zM34.126 141.41L136.9 36.13l-15.619-15.248L18.507 126.163l15.62 15.247zm11.715 377.631c-9.042 0-16.371-7.329-16.371-16.371H7.642c0 21.097 17.102 38.199 38.199 38.199v-21.828zm352.328 21.828a38.195 38.195 0 0027.01-11.188l-15.434-15.435a16.371 16.371 0 01-11.576 4.795v21.828zm-368.7-388.023a16.37 16.37 0 014.657-11.436l-15.62-15.247a38.196 38.196 0 00-10.864 26.683H29.47z'
        fill='#000'
      />
      <path
        d='M150.986 424.813h352.521c15.069 0 27.285-12.215 27.285-27.284V45.008c0-15.07-12.216-27.285-27.285-27.285H150.986c-15.069 0-27.285 12.216-27.285 27.285v352.521c0 15.069 12.216 27.284 27.285 27.284z'
        fill='#fff'
        stroke='#000'
        strokeWidth={21.8279}
      />
      <path
        d='M121.003 41.987L17.208 143.085c.45 101.548 1.348 312.463 1.348 343.736 0 31.273 16.176 41.787 24.264 43.135H409.47l99.751-103.794H160.094c-31.273 0-39.091-20.669-39.091-31.004V41.987z'
        fill='#000'
        stroke='#000'
        strokeWidth={2.69596}
      />
      <g clipPath='url(#clip0_127_212)'>
        <path
          d='M292.456 148.942v-13.183c0-7.36-5.967-13.329-13.326-13.329h-65.376c-7.358 0-13.325 5.969-13.325 13.329v171.482c0 7.36 5.967 13.329 13.325 13.329h225.492c7.358 0 13.325-5.969 13.325-13.329V175.593c0-7.36-5.967-13.329-13.325-13.329H305.782c-7.359.007-13.326-5.962-13.326-13.322z'
          stroke='#000'
          strokeWidth={20.3464}
        />
        <path
          d='M315.308 281.45c-15.247-4.849-27.189-17.059-31.809-32.284-.506-1.669.537-3.415 2.231-3.813l5.139-1.189c1.53-.354 3.054.544 3.521 2.049 3.616 11.546 12.725 20.796 24.331 24.482 13.604 4.325 28.478.354 38.175-9.68 2.637-2.725 6.859-3.117 10.001-.999l.803.544c1.447.973 1.795 2.978.727 4.356-12.34 15.908-33.719 22.699-53.119 16.534z'
          fill='#000'
        />
        <path
          d='M301.262 243.089l-8.522-14.688c-1.618-2.788-5.651-2.782-7.256.019l-8.459 14.726c-1.605 2.801.418 6.285 3.642 6.279l16.985-.038c3.218-.006 5.228-3.503 3.61-6.298zM341.826 194.593c15.248 4.85 27.189 17.059 31.81 32.285.505 1.669-.538 3.414-2.232 3.812l-5.139 1.189c-1.53.354-3.053-.544-3.521-2.049-3.616-11.545-12.725-20.795-24.331-24.482-13.604-4.325-28.478-.354-38.175 9.681-2.636 2.725-6.859 3.117-10.001.999l-.803-.544c-1.447-.974-1.795-2.978-.727-4.357 12.34-15.908 33.719-22.699 53.119-16.534z'
          fill='#000'
        />
        <path
          d='M355.872 232.954l8.522 14.688c1.618 2.788 5.651 2.782 7.257-.019l8.458-14.726c1.605-2.801-.417-6.285-3.641-6.279l-16.986.038c-3.218.007-5.228 3.503-3.61 6.298z'
          fill='#000'
        />
      </g>
      <defs>
        <clipPath id='clip0_127_212'>
          <path fill='#fff' transform='translate(194 116)' d='M0 0H265V211H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DSyncLogo;
